import { render, staticRenderFns } from "./addLicenceManager.vue?vue&type=template&id=4cf13729"
import script from "./addLicenceManager.vue?vue&type=script&lang=js"
export * from "./addLicenceManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports